import { NavLink, NavLinkProps, useNavigate } from '@remix-run/react';

interface CleanLinkProps extends Omit<NavLinkProps, 'to'> {
	// The crawlable, filter-free URL rendered in the href
	to: string;
	// Where a normal click goes, so the user keeps their active filters
	filteredTo: string;
}

/**
 * Crawlers only see the clean URL, but a plain left click carries the user's filters across.
 * Modified clicks (new tab etc.) fall through to the clean href.
 */
export function CleanLink({ to, filteredTo, onClick, ...props }: CleanLinkProps) {
	const navigate = useNavigate();

	return (
		<NavLink
			{...props}
			to={to}
			onClick={e => {
				onClick?.(e);
				if (e.defaultPrevented || filteredTo === to) return;
				if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
				e.preventDefault();
				navigate(filteredTo);
			}}
		/>
	);
}
